module.exports = __webpack_public_path__ + "static/img/index_bg_5.7485fd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_5.jpg
// module id = 0GDD
// module chunks = 9